const actionTypes = {
    GET_DEFAULT_MATCHING_RULE_SUCCESS: 'GET_DEFAULT_MATCHING_RULE_SUCCESS',
    GET_DEFAULT_FILTERS_SUCCESS: 'GET_DEFAULT_FILTERS_SUCCESS',
    GET_DEFAULT_MATCHING_CONDITION_SUCCESS: 'GET_DEFAULT_MATCHING_CONDITION_SUCCESS',
    GET_DEFAULT_FIXED_CONDITION_SUCCESS: 'GET_DEFAULT_FIXED_CONDITION_SUCCESS',
    GET_DEFAULT_MATCH_STATUS_SUCCESS: 'GET_DEFAULT_MATCH_STATUS_SUCCESS',
    GET_REF_DATA_MATCHING_CONDITION_SUCCESS: 'GET_REF_DATA_MATCHING_CONDITION_SUCCESS',
    GET_REF_DATA_FIXED_CONDITION_SUCCESS: 'GET_REF_DATA_FIXED_CONDITION_SUCCESS',
};

export default actionTypes;